import React, { useMemo } from "react"
import I18n from "@helper/i18nInstance"
import { useRaffle } from "./RaffleContext"
import { isApiError } from "@api/types"
import RaffleHolder from "./components/RaffleHolder"
import InitPlaceholder from "../embed/components/InitPlaceholder"
import ErrorMsg from "./components/ErrorMsg"
import RaffleOpen from "./components/RaffleOpen"
import RaffleParticipating from "./components/RaffleParticipating"
import RaffleOver from "./components/RaffleOver"

export const useRaffleErrorMsg = (): string | undefined => {
  const { error } = useRaffle()

  return useMemo(() => {
    if (!error) {
      return undefined
    } else if (error === "couldNotFetch") {
      return I18n.t("raffle.error.couldNotFetch")
    } else if (error === "couldNotParticipate") {
      return I18n.t("raffle.error.couldNotParticipate")
    } else if (isApiError(error)) {
      return error.error_description || error.error
    }
    return undefined
  }, [ error ])
}

const Raffle: React.FC = () => {
  const {
    raffle,
    busy,       
  } = useRaffle()
  const errorMsg = useRaffleErrorMsg()

  if (!raffle) {
    // no raffle loaded. either initializing or error
    if (errorMsg) {
      return <RaffleHolder><ErrorMsg>{errorMsg}</ErrorMsg></RaffleHolder>
    }
    if (busy) {
      return <RaffleHolder><InitPlaceholder /></RaffleHolder>
    }
  } else if (raffle.meta.open && !(raffle.participation?.type === "participating")) {
    // open, not participating
    return <RaffleOpen />
  } else if (raffle.meta.open && raffle.participation?.type === "participating") {
    return <RaffleParticipating />
  }
  return <RaffleOver />
}

export default Raffle
